var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.16663C14.7166 5.16663 15.825 4.04996 15.825 2.66663C15.825 1.28329 14.7166 0.166626 13.3333 0.166626C11.95 0.166626 10.8333 1.28329 10.8333 2.66663C10.8333 4.04996 11.95 5.16663 13.3333 5.16663ZM6.66665 5.16663C8.04998 5.16663 9.15831 4.04996 9.15831 2.66663C9.15831 1.28329 8.04998 0.166626 6.66665 0.166626C5.28331 0.166626 4.16665 1.28329 4.16665 2.66663C4.16665 4.04996 5.28331 5.16663 6.66665 5.16663ZM6.66665 6.83329C4.72498 6.83329 0.833313 7.80829 0.833313 9.74996V11.8333H12.5V9.74996C12.5 7.80829 8.60831 6.83329 6.66665 6.83329ZM13.3333 6.83329C13.0916 6.83329 12.8166 6.84996 12.525 6.87496C13.4916 7.57496 14.1666 8.51663 14.1666 9.74996V11.8333H19.1666V9.74996C19.1666 7.80829 15.275 6.83329 13.3333 6.83329Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.63f21ba940c5d023f31f87698297d841.svg";
export { ForwardRef as ReactComponent };